import { isPlatformBrowser } from '@angular/common';
import { Component, PLATFORM_ID, inject } from '@angular/core';

@Component({
  selector: 'app-gallery-maintenance-page',
  standalone: true,
  templateUrl: './gallery-maintenance-page.component.html',
  styleUrls: ['./gallery-maintenance-page.component.scss'],
  imports: [],
})
export class GalleryMaintenancePageComponent {
  platformBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  constructor() {
    if (this.platformBrowser) {
      setTimeout(() => {
        window.location.reload();
      }, 1000 * 10);
    }
  }
}
